export function findElementPositionById(id) {
  if (!id) return;

  const element = document.getElementById(id);

  if (!element) return;

  return element.getBoundingClientRect();
}
